import UserLayout from "@/core/layouts/UnauthenticatedUserLayout.vue";
import LoginPage from "../pages/LoginPage.vue"

export default {
  path: "/login",
  component: UserLayout,
  children: [
    {
      path: "",
      name: "login",
      component: LoginPage,
      meta: { title: "تسجيل الدخول" }
    }
  ]
};
